import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';

export const useDeletePartner = (
  options?: UseMutationOptions<unknown, Error, number, unknown>,
) => {
  return useMutation<unknown, Error, number>({
    ...options,
    mutationFn: async (id: number) => {
      return axiosInstance
      .delete(getAPIURL(`/Partner/Delete?id=${id}`))
      .then((res) => res.data);
    },
  });
};